import { useState, useEffect, useMemo, useContext } from "react"
import Loader from "../Tools/Loader"
import API from "../../services/API"
import { Alert, Stack, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import Course from "../Courses/Course"
import Search from "../Inputs/Search"
import moment from "moment/moment"
import Modal from "../Tools/Modal"
import Empty from "./Empty"
import UserContext from "../../services/Context/UserContext"
import { txt } from "../../services/translation"
import VerifyingProof from "../Tools/VerifyingProof"
import PiSignatureAlert from "./PiSignatureAlert"

export default function Enrollments(){

    const { user } = useContext(UserContext)

    const navigate = useNavigate()

    const [enrollments, setEnrollments] = useState(null)
    const [search, setSearch] = useState('')
    const [status, setStatus] = useState('loading')
    const [modal, setModal] = useState(false);

    useEffect(() => {

        API.get('/study/enrollments')
            .then(r => {
                setEnrollments(r.data)
                setStatus('ready')
            })
            .catch(_ => setStatus('error'))

    }, [user])


    const items = useMemo(() => 
        (enrollments || [])
            .filter(e => e.course?.title.toLowerCase().includes(search))
    , [enrollments, search])

    

    const handleClick = enr => {

        if(enr.dpc && !enr.activated){
            return setModal(
                txt('courseAccessMessage', { date: moment(enr.activatedAt).format('DD/MM/YYYY') })
            )
        }

        if(enr.session && enr.session.started === false){
            return setModal(
                txt('courseAccessMessage', { date: moment(enr.session.start).format('DD/MM/YYYY') })
            )
        }
    
        return navigate(`/study/${enr.course?.id}`);
    }
    
    return <Stack gap={2}>

        <Typography variant='h1'>{txt('myCoursesTitle')}</Typography>

        <PiSignatureAlert />

        <Empty show={enrollments?.length === 0}/>

        {user.status.id === 'etudiant' && !user.proofVerifiedAt &&
            <VerifyingProof />
        }

        {status === 'loading' && <Loader />}
        
        {status === 'error' &&
            <Alert severity='error'>{txt('coursesLoadError')}</Alert>
        }

        {enrollments?.length > 0 && <Stack spacing={1}>

            {enrollments?.length > 4 &&
                <Search 
                    label={txt('searchInMyCourses')}
                    value={search}
                    onChange={e => setSearch(e.target.value.toLowerCase())}
                    sx={{width: 300, m: 1}}
                />
            }

            <Stack direction='row' flexWrap='wrap'>

                {items.map(e => 
                    <Course
                        key={e.id}
                        id={e.course?.id}
                        picture={e.course?.picture?.url}
                        title={e.title}
                        subtitle={e.course?.teachers}
                        dpc={e.dpc}
                        session={e.session}
                        docs={e.activated && e.session?.started !== false && `/study/${e.course?.id}/docs`}
                        completion={e.completion}
                        virtualClassroomUrl={e.virtualClassroomUrl}
                        button={txt('viewCourseButton')}
                        onClick={() => handleClick(e)}
                    />
                )}

        
            </Stack>

        </Stack>}

        <Modal
            open={modal !== false}
            onClose={() => setModal(false)}
            text={modal}
        />

    </Stack>

}


